// Structured data for the Secure AI Adoption site.
export const ORGANIZATION_JSONLD = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://digu.one/#org',
      name: 'DIGU',
      url: 'https://digu.one/',
      description:
        'DIGU secures AI coding agents inside engineering organizations. DIGU is Certified in the Claude Partner Network and is an Okta partner.',
    },
    {
      '@type': 'ProfessionalService',
      '@id': 'https://digu.one/#service',
      name: 'DIGU',
      url: 'https://digu.one/',
      parentOrganization: { '@id': 'https://digu.one/#org' },
      description:
        'DIGU secures Claude Code and the other AI coding agents your engineers use. 32 controls, built in your environment, with evidence your auditors accept.',
      areaServed: 'Worldwide',
      knowsAbout: [
        'Claude Code security',
        'AI coding agent security',
        'GitHub Copilot security',
        'Cursor security',
        'OWASP Top 10 for Agentic Applications',
        'NIST AI Risk Management Framework',
        'ISO/IEC 42001',
      ],
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Engagements',
        itemListElement: [
          'Claude Code Security and Adoption Assessment',
          'Security Hardening',
          'Claude Code Rollout',
          'Cloud Automation with Envaldi',
          'Claude Run',
        ].map((name) => ({ '@type': 'Offer', itemOffered: { '@type': 'Service', name } })),
      },
    },
  ],
};

export const faqPageJsonLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
});
